import { parseISO, parse, isValid } from 'date-fns'

export const parseDate = (dateString: string): Date | null => {
  const parsedISODate = parseISO(dateString)
  if (isValid(parsedISODate)) {
    return parsedISODate
  }
  const formats = [
    'yyyy-MM-dd',
    'yyyy-MM-dd HH:mm',
    'yyyy-MM-dd HH:mm:ss',
    "yyyy-MM-dd'T'HH:mm:ss",
    "yyyy-MM-dd'T'HH:mm:ss.SSS",
    "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
    'yyyy-MM',
    'yyyy/MM/dd',
    'yyyy/MM/dd HH:mm',
    'yyyy/MM/dd HH:mm:ss',
    'MM/dd/yyyy',
    'yyyy/MM',
    'yyyyMMdd',
    'yyyyMM',
  ]

  for (const format of formats) {
    const parsedDate = parse(dateString, format, new Date())
    if (isValid(parsedDate)) {
      return parsedDate
    }
  }
  console.error('Invalid date string:', dateString)

  return null
}
